<template>
  <v-container fluid>
    <v-layout>
      <v-flex>
        <h1 class="headline mt-2">Funnel View</h1>
      </v-flex>
      <v-flex class="text-xs-right">
        <span>
          <v-btn @click="exportData" outline color="grey" class="ma-0 mb-1">
            <i class="fas fa-file-export mr-1"></i>
            {{ $t('export') }}
          </v-btn>
        </span>
        <v-btn outline color="primary" @click="showSearch = true" :loading="loading"
          >Filter/Search by Date</v-btn
        >

        <v-dialog v-model="showSearch" persistent max-width="600" scrollable>
          <v-card>
            <div class="text-xs-right">
              <v-btn small flat fab @click="showSearch = false" :loading="loading">
                <v-icon>close</v-icon>
              </v-btn>
            </div>
            <v-divider></v-divider>
            <v-card-text max-height="600">
              <v-layout wrap>
                <v-flex xs12 sm6 class="px-1">
                  <div class="caption">Group</div>
                  <multiselect
                    class="mb-3"
                    :disabled="['only_me', 'only_group', 'only_subgroup'].includes(view_ticket)"
                    v-model="filter.group"
                    :options="agentGroupOptions"
                    label="groupname"
                    selectLabel
                    selectedLabel
                    :allow-empty="false"
                    :searchable="false"
                    deselect-label
                    @input="onChangeGroup"
                    track-by="groupname"
                  ></multiselect>
                </v-flex>
                <template v-if="filter.group && filter.group.id != null">
                  <v-flex xs12 sm6 class="px-1">
                    <div class="caption">Sub Group</div>
                    <multiselect
                      class="mb-3"
                      :disabled="['only_me', 'only_subgroup'].includes(view_ticket)"
                      v-model="filter.subgroup"
                      :key="`sub_${filter.group.id}`"
                      :options="agentSubGroupOptions"
                      label="subgroupname"
                      selectLabel
                      selectedLabel
                      :allow-empty="false"
                      :searchable="false"
                      deselect-label
                      @input="onChangeSubGroup"
                      track-by="subgroupname"
                    ></multiselect>
                  </v-flex>
                </template>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs6>
                  <div>
                    <div class="caption">Start Date</div>
                    <v-layout>
                      <v-flex xs10>
                        <DatePickerWithoutButton v-model="selectedDate.start">
                          <div class="form-control">
                            <input type="text" :value="getDate(selectedDate.start)" readonly />
                          </div> </DatePickerWithoutButton
                      ></v-flex>
                      <v-flex xs2>
                        <v-btn icon @click="selectedDate.start = null">
                          <v-icon>close</v-icon></v-btn
                        >
                      </v-flex>
                    </v-layout>
                  </div></v-flex
                >
                <v-flex xs6>
                  <div>
                    <div class="caption">End Date</div>
                    <v-layout>
                      <v-flex xs10>
                        <DatePickerWithoutButton v-model="selectedDate.end">
                          <div class="form-control">
                            <input type="text" :value="getDate(selectedDate.end)" readonly />
                          </div> </DatePickerWithoutButton
                      ></v-flex>
                      <v-flex xs2>
                        <v-btn icon @click="selectedDate.end = null"> <v-icon>close</v-icon></v-btn>
                      </v-flex>
                    </v-layout>
                  </div></v-flex
                >
                <v-flex
                  xs12
                  class="form-control pa-1"
                  :class="{ 'has-error': errorFilterTag.length > 0 }"
                >
                  <label for>{{ $t('Name') }}</label>
                  <input type="text" v-model="filter.realname" />
                </v-flex>
                <v-flex
                  xs12
                  class="form-control pa-1"
                  :class="{ 'has-error': errorFilterTag.length > 0 }"
                >
                  <label for>{{ $t('Tag') }}</label>

                  <tags
                    v-model="tag"
                    :tags="tags"
                    @tags-changed="addTags"
                    @before-adding-tag="checkTag"
                    style="margin-bottom: 10px"
                    :btnText="$t('Add tag')"
                    :isDrag="false"
                  ></tags>

                  <span class="text-error" v-if="errorFilterTag.length > 0">
                    <template v-if="errorFilterTag.includes('overmaxlength')">{{
                      $t('Message cannot be longer than 20 alphabets')
                    }}</template>
                    <template v-else-if="errorFilterTag.includes('duplicate')">{{
                      $t('Duplicate Tag')
                    }}</template>
                  </span>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" depressed @click="onSearch" :loading="loading">
                {{ $t('Search') }}
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
    <div class="mb-2">
      <v-chip dark color="blue" v-for="(item, k) in showFilter" :key="k">{{ item }}</v-chip>
      <v-btn style="float: right" :loading="loading" @click="onSearch" color="primary" icon>
        <i class="fas fa-sync-alt"></i>
      </v-btn>
    </div>

    <div v-if="loading" class="py-5 text-xs-center">
      <v-progress-circular indeterminate color="primary "></v-progress-circular>
    </div>

    <div
      v-else
      class="pa-2"
      style="height: calc(100vh - 112px); overflow-x: auto; overflow-y: visible"
    >
      <v-layout
        justify-start
        align-start
        fill-height
        row
        class="mb-0 ml-0"
        :style="{ width: groups.length * 310 + 'px' }"
      >
        <template v-for="group in groups">
          <funnel-line
            :value="group"
            :key="group.text + '_' + timestamp"
            :data="users"
            @onMoveToAnotherLine="onMoveToAnotherLine"
          ></funnel-line>
        </template>
      </v-layout>
    </div>
  </v-container>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import FunnelLine from './FunnelLine'
import moment from 'moment'
import datepicker from 'vuejs-datepicker'
import Multiselect from 'vue-multiselect'
import XLSX from 'xlsx'
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'
import Tags from '@/components/elements/Tags'

const DateRangePicker = () => import('./DateRangePicker')
export default {
  computed: {
    moment() {
      return moment
    },
    tags: {
      get() {
        let vm = this
        if (vm.filter && vm.filter.tags && vm.filter.tags !== '') {
          var tags = []
          tags = vm.filter.tags.split(',')
          var result = []
          if (tags) {
            tags.map(function (tag, index) {
              result.push({ text: tag })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function (tag, index) {
            result.push(tag.text)
          })
        }
        vm.filter.tags = result.join(',')
      },
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      agentGroup: 'getAgentGroup',
      loadingAgentGroup: 'getLoadingAgentGroup',
      agentSubGroup: 'getAgentSubgroup',
      loadingAgentSubGroup: 'getLoadingAgentSubgroup',
      agents: 'getAgent',
      loadingAgent: 'getLoadingAgent',
    }),
    showFilter() {
      var result = []

      if (this.filter.group && this.filter.group.groupname != 'All') {
        result.push(`Group: ${this.filter.group.groupname}`)
      }
      if (this.filter.subgroup && this.filter.subgroup.subgroupname != 'All') {
        result.push(`Sub Group: ${this.filter.subgroup.subgroupname}`)
      }
      if (this.filter.admin && this.filter.admin.name != 'All') {
        result.push(`Name: ${this.filter.admin.name}`)
      }
      if (this.selectedDate.start) {
        result.push(
          `Start Date: ${moment(this.selectedDate.start).format('DD/MM/YYYY')} ${
            this.selectedDate.starttime ? this.selectedDate.starttime : ''
          }`
        )
      }
      if (this.selectedDate.end) {
        result.push(
          `End Date: ${moment(this.selectedDate.end).format('DD/MM/YYYY')} ${
            this.selectedDate.endtime ? this.selectedDate.endtime : ''
          }`
        )
      }
      if (this.filter.tags) {
        result.push(`Tags: ${this.filter.tags}`)
      }

      if (this.filter.realname) {
        result.push(`Name: ${this.filter.realname}`)
      }

      return result
    },

    agentGroupOptions() {
      return this.loadingAgentGroup
        ? []
        : [
            {
              groupname: 'All',
              id: null,
            },
            ...this.agentGroup,
          ]
    },
    agentSubGroupOptions() {
      if (!this.filter.group) {
        return []
      }
      var subgroup = this.agentSubGroup.filter((el) => {
        return el.admingroupid == this.filter.group.id
      })
      return this.loadingAgentSubGroup
        ? []
        : [
            {
              subgroupname: 'All',
              id: null,
            },
            ...subgroup,
          ]
    },
  },
  components: {
    FunnelLine,
    datepicker,
    DateRangePicker,
    Multiselect,
    DatePickerWithoutButton,
    Tags,
  },
  data() {
    return {
      realname: '',
      tag: '',
      refreshInterval: null,
      groups: [
        {
          text: 'Chat with bot',
          value: 'open',
        },
        {
          text: 'Pending',
          value: 'pending',
        },
        {
          text: 'Answered',
          value: 'answered',
        },
        {
          text: 'Closed',
          value: 'closed',
        },
        {
          text: 'Cancelled',
          value: 'cancelled',
        },
        {
          text: 'Cancelled Ticket by Customer',
          value: 'cancelled by customer',
        },
      ],
      users: [],
      loading: true,
      timestamp: moment().format('x'),
      selectedDate: {
        start: moment().format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD'),
        starttime: null,
        endtime: null,
      },
      showSearch: false,
      filter: {
        tags: '',
        group: {
          groupname: 'All',
          id: null,
        },
      },
      view_ticket: '',
      errorFilterTag: [],
    }
  },
  async mounted() {
    var vm = this
    try {
      this.initFilter()
      // var filter = this.formatFilter()
      this.offset = 0

      await this.getTicketsByStatus()
      vm.refreshInterval = setInterval(async () => {
        await this.getTicketsByStatus()
      }, 60000)
    } catch (error) {
      console.error(error)
    }
  },
  beforeDestroy() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval)
    }
  },
  methods: {
    checkTag(obj) {
      this.errorFilterTag = []
      if (obj.tag.text.length > 9999) {
        this.errorFilterTag.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorFilterTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    addTags: function (newTags) {
      this.tags = newTags
    },

    getDate(date) {
      if (date) {
        return moment(date).format('DD/MM/YYYY')
      } else {
        return ''
      }
    },
    exportData() {
      let vm = this
      let header = 'data:text/csv;charset=utf-8,%EF%BB%BF'
      let csvContent = ''
      let orders = []
      let filename = 'funnel'

      var json = []
      json = this.users.map((el) => {
        return {
          Priority: el.priority ? el.priority : '-',
          Name: el.first_name ? el.first_name + ' ' + el.last_name : '-',
          'Latest Email': el.email ? el.email : '-',
          Channel: el.channel ? el.channel : '-',
          Subject: el.subject ? el.subject : '-',
          Details: el.details ? el.details : '-',
          Status: el.status ? el.status : '-',
          'Assign To': el.assignadminid ? el.assignadminid : '-',
          'Start time': el.starttime ? moment(el.starttime).format('DD/MM/YYYY HH:mm') : '-',
          'End Time': el.endtime ? moment(el.endtime).format('DD/MM/YYYY HH:mm') : '-',
          'Due Date': el.duedate ? el.duedate : '-',
          Tags: el.tags ? el.tags : '-',
        }
      })

      var dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, filename + '.xlsx')
    },
    onfilterUsers() {
      if (this.$store.state.privilege) {
        switch (this.$store.state.privilege.view_ticket) {
          case 'all':
            return this.users
          case 'only_me':
            return this.users.filter((el) => {
              return el.assignadminid == this.$store.state.userid
            })
          case 'only_group':
            return this.users.filter((el) => {
              return el.assigngroupid == this.$store.state.admingroupid
            })
          case 'only_subgroup':
            return this.users.filter((el) => {
              return el.assignsubgroupid == this.$store.state.adminsubgroupid
            })
          default:
            return []
        }
      } else {
        return []
      }
    },
    initFilter() {
      var admingroupid = this.$store.state.admingroupid
      var adminsubgroupid = this.$store.state.adminsubgroupid
      var filter = {}
      var group = {}
      var subgroup = {}
      this.agentGroup.map((el) => {
        group[el.id] = el
      })
      this.agentSubGroup.map((el) => {
        subgroup[el.id] = el
      })

      // var group = this.agentGroup
      this.view_ticket = this.$store.state.privilege.view_ticket
      if (this.view_ticket == 'all') {
        // dont do shit
      } else if (this.view_ticket == 'only_me') {
        this.filter.assignadminid = this.$store.state.userid
        Object.assign(filter, {
          assignadminid: this.$store.state.userid,
        })
        if (admingroupid || admingroupid === 0) {
          this.filter.group = group[admingroupid]
        }
        if (adminsubgroupid || adminsubgroupid === 0) {
          this.filter.subgroup = subgroup[adminsubgroupid]
        }
        if (this.agents) {
          this.filter.admin = this.agents.find((el) => el.adminid == this.$store.state.userid)
        }
      } else if (this.view_ticket == 'only_group') {
        Object.assign(filter, {
          assigngroupid: admingroupid,
        })

        if (admingroupid || admingroupid === 0) {
          this.filter.group = group[admingroupid]
        }
      } else if (this.view_ticket == 'only_subgroup') {
        Object.assign(filter, {
          assignsubgroupid: adminsubgroupid,
        })
        if (admingroupid || admingroupid === 0) {
          this.filter.group = group[admingroupid]
        }
        if (adminsubgroupid || adminsubgroupid === 0) {
          this.filter.subgroup = subgroup[adminsubgroupid]
        }
      }
    },
    formatFilter() {
      var data = {}
      if (this.filter.group && this.filter.group.id != null) {
        data.assigngroupid = this.filter.group.id
      }

      if (this.filter.subgroup && this.filter.subgroup.id != null) {
        data.assignsubgroupid = this.filter.subgroup.id
      }
      if (this.filter.assignadminid && this.filter.assignadminid != null) {
        data.assignadminid = this.filter.assignadminid
      }
      if (this.filter.realname && this.filter.realname != null) {
        data.realname = this.filter.realname
      }
      if (this.filter.tags && this.filter.tags != null) {
        data.tags = this.filter.tags
      }

      if (this.selectedDate.start) {
        data.starttime = moment(this.selectedDate.start).format('YYYY-MM-DD')
      }

      if (this.selectedDate.end) {
        data.endtime = moment(this.selectedDate.end).format('YYYY-MM-DD')
      }
      return data
    },
    onChangeGroup(val) {
      if (val.id) {
        this.$set(this.filter, 'subgroup', { id: null, subgroupname: 'All' })
      } else {
        this.$set(this.filter, 'subgroup', null)
      }
    },
    onChangeSubGroup(val) {},
    async onSearch() {
      var vm = this
      try {
        vm.offset = 0

        vm.$nextTick(async () => {
          await vm.getTicketsByStatus()
        })
      } catch (error) {
        console.log(error)
      }

      this.showSearch = false
    },
    onMoveToAnotherLine(payload) {
      var index = this.users.findIndex((el) => {
        return el.id == payload.id
      })
      if (index != -1) {
        this.$set(this.users, index, payload)
      }
      this.timestamp = moment().format('x')
    },
    calculateTicket(data) {
      var list = {}
      var agents = []
      data.map((el) => {
        if (list.hasOwnProperty(el.adminid)) {
          list[el.adminid].all += parseInt(el.amount)
          switch (el.status) {
            case 'answered':
              list[el.adminid].answered += parseInt(el.amount)
              break
            case 'pending':
              list[el.adminid].pending += parseInt(el.amount)
              break
            case 'closed':
              list[el.adminid].closed += parseInt(el.amount)
              break
            case 'canceled':
              list[el.adminid].cancelled += parseInt(el.amount)
              break

            default:
              break
          }
        } else {
          list[el.adminid] = {
            adminid: el.adminid,
            name: el.name,
            all: parseInt(el.amount),
            pending: 0,
            closed: 0,
            cancelled: 0,
          }

          switch (el.status) {
            case 'answered':
              list[el.adminid].answered += parseInt(el.amount)
              break
            case 'pending':
              list[el.adminid].pending += parseInt(el.amount)
              break
            case 'closed':
              list[el.adminid].closed += parseInt(el.amount)
              break
            case 'cancelled':
              list[el.adminid].cancelled += parseInt(el.amount)
              break
              break

            default:
              break
          }
        }
      })

      for (const key in list) {
        if (list.hasOwnProperty(key)) {
          const element = list[key]
          agents.push(element)
        }
      }

      return agents
    },
    getTicketsByStatus() {
      var vm = this
      this.loading = true
      var filter = vm.formatFilter()
      var data = {
        pageid: this.selectedBot.pageid,
        ...filter,
      }
      return new Promise((resolve, reject) => {
        api.getTicketsByStatus(data, (error, response) => {
          this.loading = false
          if (error) {
            console.error(error)
            reject(error)
          }
          if (response.data) {
            this.users = response.data
          }
          resolve(response)
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/ticket2/management/Funnel.vue